export default function DuckCrest({ size = 56, color = "#B4893B" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="45" cy="60" rx="28" ry="20" fill={color} />
      <ellipse cx="48" cy="58" rx="22" ry="14" fill="none" stroke="rgba(0,0,0,0.25)" strokeWidth="1.5" />
      <path d="M28 58 Q38 48 55 52" stroke="rgba(0,0,0,0.2)" strokeWidth="1" fill="none"/>
      <path d="M30 63 Q40 54 55 58" stroke="rgba(0,0,0,0.2)" strokeWidth="1" fill="none"/>
      <path d="M32 68 Q42 60 56 63" stroke="rgba(0,0,0,0.2)" strokeWidth="1" fill="none"/>
      <path d="M58 60 Q68 55 64 42 Q62 35 56 32" stroke={color} strokeWidth="10" strokeLinecap="round" fill="none"/>
      <ellipse cx="55" cy="28" rx="12" ry="10" fill={color} />
      <circle cx="60" cy="25" r="2.5" fill="rgba(0,0,0,0.7)" />
      <circle cx="61" cy="24" r="0.8" fill="rgba(255,255,255,0.5)" />
      <path d="M67 27 L75 26 L74 30 L66 29 Z" fill={color} stroke="rgba(0,0,0,0.2)" strokeWidth="0.8"/>
      <path d="M17 55 Q8 45 14 35 Q18 38 20 48 Q22 54 17 55 Z" fill={color}/>
      <path d="M20 58 Q11 50 16 40 Q20 44 21 52 Z" fill={color} opacity="0.8"/>
      <path d="M38 78 L34 86 L44 86 M38 78 L38 86" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M52 78 L48 86 L58 86 M52 78 L52 86" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
      <circle cx="42" cy="55" r="3" fill="none" stroke="rgba(0,0,0,0.2)" strokeWidth="0.8"/>
      <circle cx="50" cy="52" r="3" fill="none" stroke="rgba(0,0,0,0.2)" strokeWidth="0.8"/>
      <circle cx="47" cy="62" r="3" fill="none" stroke="rgba(0,0,0,0.2)" strokeWidth="0.8"/>
      <circle cx="38" cy="60" r="2.5" fill="none" stroke="rgba(0,0,0,0.2)" strokeWidth="0.8"/>
    </svg>
  );
}
